import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { Link, LinkIcon } from '../'
import config from '../../config'
import Styles from './DiversityEeoStatement.css'

@CSSModules(Styles)
export default class DiversityEeoStatement extends Component {
  static propTypes = {
    fundId: PropTypes.string.isRequired,
    shareclassId: PropTypes.string.isRequired,
    shareName: PropTypes.string.isRequired
  }
  constructor(props){
    super(props);
  }
  render() {
    const ussifProfile = config.ussifFundsDiversityEeo[this.props.fundId]
    const r = ussifProfile.r
    const result = config.ussifFundsDiversityEeoOptions[r]
    const uid = ussifProfile.s[this.props.shareclassId]
    const url = uid ? `https://charts.ussif.org/mfpc/fund_profile_display.php?FundID=${uid}` : 'https://charts.ussif.org/mfpc'
    const ussifLogo = require( '../../../static/images/ussif-memberlogo.png' )
    return (
      <div styleName='eeo-wrap'>
        <img
          styleName='img'
          src={ussifLogo}
          alt='Member of USSIF'
        />
        <div styleName='lede'>
          This fund is a member of a sustainable and responsible investing group, and has a posted policy on their consideration of diversity and equal employment opportunity policies and practices relating to employees, company ownership or contractors.
        </div>
        <div styleName='statement-wrap'>
          <div styleName='statement'>
            {result}.
            &nbsp;
            <Link
              to={url} title={this.props.shareName + ' | USSIF'}
              xstrong={true}
            >
              More<LinkIcon />
            </Link>
          </div>
        </div>
          <div styleName='contact'>
            US-SIF member fund managers: want to update your statement?
            &nbsp;
            <Link
              to={config.links.contact}
              title='Contact us to update your diversity and EEO investment statements'
              xstrong={true}
            >
              <strong>
                Contact us<LinkIcon faclass='fa-envelope-o'/>
              </strong>
            </Link>
          </div>

      </div>
    )
  }
}

